import { createSlice } from "@reduxjs/toolkit";

export const companyDataSlice = createSlice({
  name: "Company Details",
  initialState: {
    companyDetails: {
      organizationID: '',
      companyID: '',
      shopName: '',
      bigLogoURL: '',
      smallLogoURL: '',
      siteURL: '',
      address: '',
      email: '',
      contactNumber: '',
    },
    company: null,
    settings: {},
    pages: [],
    categories: localStorage.getItem("ECOM_CAT") ? JSON.parse(localStorage.getItem("ECOM_CAT")) : [],
    categoryProducts: localStorage.getItem("ECOM_CAT_PROD") ? JSON.parse(localStorage.getItem("ECOM_CAT_PROD")) : [],
    selectedCategory: localStorage.getItem("ECOM_CAT_SL") ? JSON.parse(localStorage.getItem("ECOM_CAT_SL")) : null,
    cart: localStorage.getItem("ECOM_CART") ? JSON.parse(localStorage.getItem("ECOM_CART")) : [],
    wishlist: localStorage.getItem("ECOM_WL") ? JSON.parse(localStorage.getItem("ECOM_WL")) : [],
    companies: [],
    selectedOffer: localStorage.getItem("ECOM_OFF_SL_ID") ? JSON.parse(localStorage.getItem("ECOM_OFF_SL_ID")) : "",
    storeClosed: {
      "delivery": false,
      "collection": false,
      "table": false
    },
    preparationSettings: null,
    isComing: false,
    isCartOpen: false

  },

  reducers: {
    setCompanyData: (state, action) => {
      state.companyDetails = { ...action.payload };
    },
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    setSettingsData: (state, action) => {
      state.settings = { ...action.payload };
    },
    setPages(state, action) {
      state.pages = action.payload
    },
    setCompany(state, action) {
      state.company = action.payload
    },
    setCategories(state, action) {
      state.categories = action.payload
      state.selectedCategory = action.payload.length > 0 ? action.payload[0] : null
      localStorage.setItem("ECOM_CAT", JSON.stringify(action.payload))
      if (action.payload.length > 0) {
        localStorage.setItem("ECOM_CAT_SL", JSON.stringify(action.payload[0]))
      }
    },
    setCategoryProducts(state, action) {
      state.categoryProducts = action.payload
      localStorage.setItem("ECOM_CAT_PROD", JSON.stringify(action.payload))
    },
    setSelectedCategory(state, action) {
      state.selectedCategory = action.payload
      localStorage.setItem("ECOM_CAT_SL", JSON.stringify(action.payload))
    },
    setCart(state, action) {
      state.cart = action.payload
      if (action.payload.length === 0) {
        localStorage.removeItem("ECOM_CART")
      } else {
        localStorage.setItem("ECOM_CART", JSON.stringify(action.payload))

      }
    },
    setWishlist(state, action) {
      state.wishlist = action.payload
      if (action?.payload) {
        if (action?.payload?.length === 0) {
          localStorage.removeItem("ECOM_WL")
        } else {
          localStorage.setItem("ECOM_WL", JSON.stringify(action.payload))

        }
      } else {
        localStorage.removeItem("ECOM_WL")
      }
    },
    setSelectedOffer(state, action) {
      state.selectedOffer = action.payload
      if (action.payload !== "") {
        localStorage.setItem("ECOM_OFF_SL_ID", JSON.stringify(action.payload))
      } else {
        localStorage.removeItem("ECOM_OFF_SL_ID")
      }
    },
    setStoreClosed(state, action) {
      state.storeClosed = action.payload
    },
    setPreparationSettings(state, action) {
      state.preparationSettings = action.payload
    },
    setIsComing(state, action) {
      state.isComing = action.payload
    },
    setIsCartOpen(state, action) {
      state.isCartOpen = action.payload
    },
  },
});

export const { setCompanies, setCompanyData, setSettingsData, setPages, setCompany, setCategories, setCategoryProducts, setSelectedCategory, setCart, setWishlist, setSelectedOffer, setStoreClosed, setPreparationSettings, setIsComing, setIsCartOpen } = companyDataSlice.actions;

export default companyDataSlice.reducer;